import { DecisionStatusType } from 'Types/Tasks.types'
import { ActionConfig, ActionContext, IAction } from '../Action'
import { sendAnalyticsTrack } from 'Utils/analytics.utils'

export class FinishReviewAction implements IAction {
    static Id = 'FinishReview' as const
    constructor(
        private actionContext: ActionContext,
        private config?: ActionConfig
    ) {
        this.addToWorkbench()
    }

    addToWorkbench() {
        this.actionContext.workbenchUiAccessor?.toolbar.addAction(
            {
                id: 'finish-review',
                title: this.config?.title ?? 'Finish Review',
                type: 'button',
                color: 'primary',
                tooltip: this.config?.tooltip,
                disabled: this.config?.disabled ?? false,
                children: this.config?.children ?? [
                    {
                        id: 'edit',
                        title: 'Edit the Response',
                        onClick: () => {
                            this.actionContext.task.taskState.setDecision({
                                status: DecisionStatusType.ACCEPT,
                                schema_version: 1,
                            })
                            this.actionContext.modalManager?.showModal('action-modal')
                            this.actionContext.task.ui?.updater.forceUpdate()
                            this.actionContext.task.updateAttributesUI()
                        },
                    },
                    {
                        id: 'reject',
                        title: 'Reject & Send Back',
                        onClick: () => {
                            sendAnalyticsTrack('RejectCTA_Clicked', {
                                ...this.actionContext.task.getCommonAnalyticsObject(),
                                ...this.actionContext.studio.pluginManager.getPluginAnalyticsData(
                                    'AI Assistance'
                                ),
                                ...this.actionContext.studio.pluginManager.getPluginAnalyticsData(
                                    'Plagiarism'
                                ),
                                duration_since_task_start: Math.floor(
                                    this.actionContext.studio.taskManager.timer.getElapsedTime() /
                                        1000
                                ),
                            })
                            this.actionContext.modalManager?.showModal('reject-or-skip-modal')
                            if (
                                this.actionContext.modalManager?.getModalMetaData(
                                    'reject-or-skip-modal'
                                )
                            ) {
                                const rejectTaskConfig =
                                    this.actionContext.studio.taskConfig.assignment.task.config
                                        .reject_task_config
                                this.actionContext.modalManager?.updateModalMetaData(
                                    'reject-or-skip-modal',
                                    {
                                        isSkip: false,
                                        rejectionReasons: rejectTaskConfig?.rejection_reasons,
                                        isRejectionReasonSelectionOptional:
                                            rejectTaskConfig?.is_reason_optional,
                                    }
                                )
                            }
                            this.actionContext.task.ui?.updater.forceUpdate()
                        },
                    },
                    {
                        id: 'accept',
                        title: 'Accept the Response',
                        onClick: async () => {
                            const config = this.actionContext.studio.taskConfig
                            const errors =
                                this.actionContext.studio.inputManager.getViolationCount('error')
                            if (errors > 0) {
                                this.actionContext.modalManager?.showModal('violations-modal')
                                this.actionContext.task.ui?.updater.forceUpdate()
                                return
                            }

                            this.actionContext.task.taskState.setDecision({
                                status: DecisionStatusType.ACCEPT,
                                schema_version: 1,
                            })
                            const submitModalMetaData =
                                this.actionContext.modalManager?.getModalMetaData('submit-modal')
                            if (submitModalMetaData) {
                                this.actionContext.modalManager?.updateModalMetaData(
                                    'submit-modal',
                                    {
                                        isAccept: true,
                                        taskMode: config.mode,
                                    }
                                )
                            }
                            this.actionContext.modalManager?.showModal('submit-modal')
                        },
                    },
                ],
            },
            this.config?.placement
        )
    }

    removeFromWorkbench(): void {
        this.actionContext.workbenchUiAccessor?.toolbar.removeAction('finish-review')
    }
}
